import { getApiKeyAndFilters } from "../../utils/localStorage";

export function useApiKey() {
  const { api_key } = getApiKeyAndFilters();
  return api_key;
}
